const hostname = window.location.hostname;

let stage = "uat";

switch (hostname) {
  case "localhost":
    stage = "dev";
    break;
  case "adsdev.lumimatrimony.com":
    stage = "dev";
    break;
  case "adsuat.lumimatrimony.com":
    stage = "uat";
    break;
  case "ads.lumimatrimony.com":
    stage = "prod";
    break;
  default:
    stage = "dev";
}

export const BASE_URL = `/${stage}/v1`;

export const API_ENDPOINTS = {
    BASE_URL,
    AUTH: {
        LOGIN: `${BASE_URL}/login`,
        VERIFY_OTP: '/verify/otp',
        VALIDATE_GST: '/validateGst',
        PAN_VERIFICATION: '/panVerification'
    },

    USER: {
        DATA: '/accessContact'
    },
    VIEW: {
        DATA: '/viewContact'
    },
    WORKS: {
        GET_ALL: `${BASE_URL}/work/all`,
        ADD: `${BASE_URL}/work`,
        DELETE: `${BASE_URL}/work`
    },
    TRANSACTION: {
        GET_ALL: `${BASE_URL}/get/transactions`
    },
    CATALOGS: {
        GET_ALL: `${BASE_URL}/catalog/all`,
        ADD: `${BASE_URL}/catalog`,
        UPDATE: `${BASE_URL}/catalog/`,
        DELETE: (id) => `${BASE_URL}/catalog/${id}`
    },
    DASHBOARD: {
        GET: `${BASE_URL}/dashboard/get?status=active`
    },
    ADS: {
        GET_ALL: `${BASE_URL}/ads/all`,
        GET_INDIVIDUAL_AD: `${BASE_URL}/get/ad`,
        ADD: `${BASE_URL}/ad`,
        UPDATE: `${BASE_URL}/update/ad`,
        GET_AD_PLAN: `${BASE_URL}/plan/all`,
        CREATE_AD: `${BASE_URL}/ad`
    },
    BUSINESS_INFO: {
        CATEGORIES: '/business/category/all',
        GET: `${BASE_URL}/vendor/info`,
        UPDATE: `${BASE_URL}/vendor/info/update`
    },
    MOBILE_VIEW: {
        DASHBOARD: `${BASE_URL}/mobile/view/dashboard?sentAd=true`,
        LISTING: `${BASE_URL}/mobile/view/listing?sentAd=true`
    },
    NOTIFICATION: {
        GET: `${BASE_URL}/getNotifications`
    },
    UPDATE_PHONE: {
        UPDATE: '/update/phone',
        UPDATE_VERIFY_OTP: '/update/verify/otp'
    },
    PAYMENT: {
        GET: '/generate/invoice?transactionId=',
        GATEWAY: '/get/backend/config'
    },
    GET_STATE: '/state/list'
};
